import { cx } from "@linaria/core"
import { Slot } from "@radix-ui/react-slot"

import { ButtonStyles } from "@/components/Button/ButtonStyles.ts"

import type { ButtonHTMLAttributes, RefAttributes } from "react"


type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & RefAttributes<HTMLButtonElement> & {
  kind?: ButtonKind
  size?: ButtonSize
  asChild?: boolean
  active?: string
}

export type ButtonKind =
  "default"
  | "alternative"
  | "primary"
  | "secondary"
  | "danger"
  | "success"
  | "whoosh"
  | "icon"
  | "icon-rounded"

export type ButtonSize = "default" | "small" | "large"

const Button = ({ asChild = false, className, ref, ...props }: ButtonProps) => {
  const Comp = asChild ? Slot : "button"
  let kindClassName = ButtonStyles.Kind.Regular
  if (props.kind === "alternative") {
    kindClassName = ButtonStyles.Kind.Alternative
  } else if (props.kind === "primary") {
    kindClassName = ButtonStyles.Kind.Primary
  } else if (props.kind === "secondary") {
    kindClassName = ButtonStyles.Kind.Secondary
  } else if (props.kind === "danger") {
    kindClassName = ButtonStyles.Kind.Danger
  } else if (props.kind === "success") {
    kindClassName = ButtonStyles.Kind.Success
  } else if (props.kind === "whoosh") {
    kindClassName = ButtonStyles.Kind.Whoosh
  } else if (props.kind === "icon") {
    kindClassName = ButtonStyles.Kind.Icon
  } else if (props.kind === "icon-rounded") {
    kindClassName = ButtonStyles.Kind.IconRounded
  }

  let sizeClassName = null
  if (props.size == "small") {
    if (props.kind === "icon") {
      sizeClassName = ButtonStyles.Size.SmallIcon
    } else if (props.kind === "icon-rounded") {
      sizeClassName = ButtonStyles.Size.SmallIconRounded
    } else {
      sizeClassName = ButtonStyles.Size.Small
    }
  } else if (props.size == "large") {
    if (props.kind === "icon-rounded") {
      sizeClassName = ButtonStyles.Size.LargeIconRounded
    } else {
      sizeClassName = ButtonStyles.Size.Large
    }
    // TODO add large size for other kinds as needed
  }

  return (
    <Comp
      ref={ref}
      className={cx(ButtonStyles.Base, kindClassName, sizeClassName, className)}
      data-force-active={props.active}
      {...props}
    />
  )
}

export { Button }
